import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "True love",
  "description": "",
  "published": "2008-08-13T00:00:00.000Z",
  "redirect_from": ["/blog/true-love/swizec/83"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`My girlfriend isn't a drop-dead gorgeous person, in fact I'm certain to many she doesn't even seem attractive. She's a tad on the chubby side, has strange fingernails, weirdly positioned teeth, strange jaw-bone structure, could do with a tad better cheekbones, her eyes aren't properly aligned on her face, she doesn't have long legs and doesn't seem to know how to make herself look better with make-up and clothing. She's not even that great personality-wise, she's whiny, sulky, has a lot of baggage and she's prone to burst of such deep despair it makes your heart shrivel up and die.`}</p>
    <p>{`But you know what? None of that really matters and I hope she doesn't change any of it save for the personality stuff. It's what makes her her and I enjoy every little imperfection I can find because to me she's the prettiest and awesomest person there can be.`}</p>
    <p>{`That, I believe, is true love. I'm still not quite certain how it comes about, but at least I've now figured out what it is ... it's knowing all of your partner's flaws and simply not finding them at all important. To knowingly be with someone despite all their problems and imperfections, what else could that be than love?`}</p>
    <p>{`Despair perhaps, a fluke of monogamic social organisation ... but let's call it love for now.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      